<template>
    <div class="container_wh h-screen flex flex-row " v-if="firstPage">
            <!--左边菜单-->
            <div class="left_menu h-full pt-20">
                    <router-link to="/member">
                    <div class=" menu leading-none cursor-pointer text-center text-white" :class="{menu_active:metaGroup=='member'}"   >
                        <i class="iconfont icon-vip-card-o" ></i>
                        <p class="text-2xl leading-none">会员</p>
                    </div>
                    </router-link>
                     <router-link to="/set">
                    <div class="menu leading-none cursor-pointer text-center text-white mt-40" :class="{menu_active:metaGroup=='set'}"  >
                        <i class="iconfont icon-options" ></i>
                        <p class="text-2xl leading-none">设置</p>
                    </div>
                    </router-link>
            </div>

            <!--右边-->
            <div class="right_content flex-1 ">

    <div class="top_menu flex items-center justify-between pr-10 pl-5 ">
        <div class="tools" v-if="metaTier==0">
            <span class="pl-3 text-xl font-bold">{{metaTitle}}</span>
        </div>

        <div style="width:150px;"    v-if="metaTier==1">

             <el-button round @click="goBack">返回</el-button>
             <span class="text-xl base_color font-bold absolute left-28 top-5">{{metaTitle}}</span>
        </div>

        <div class="title text-center flex-1" style="min-width:200px;">
            <p class="text-lg">{{user.branch_name}}</p>
            <p class="text-xs text-gray-400 pt-1">{{user.terminal_name}}</p>
        </div>
        <div class="about flex items-center justify-between">
              <div>
                  <p><i class="iconfont icon-line-user" style="font-size:13pt;"></i><span class="text-base pl-1">{{user.user_name}}</span></p>
                  <p class="text-xs pt-1">工号：{{user.user_code}}</p>
              </div>
              <div class="flex items-center base_color cursor-pointer" @click="doExitDialog=true">
                  <i class="iconfont icon-tuichu"  style="font-size:18pt;"></i>
                  <span class="text-base pl-1">退出</span>
              </div>
        </div>
    </div><!--top_menu-->

                  <router-view/>
            </div>
    </div>
    <div v-else>
         <router-view/>
    </div>

 <el-dialog
    v-model="doExitDialog"
    title="提示"
    width="30%"
  >
    <span>是否确定退出登录？</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="doExitDialog = false">取消</el-button>
        <el-button type="primary" @click="doExit"
          >确定</el-button
        >
      </span>
    </template>
  </el-dialog>

</template>
<script>
import { computed, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ElLoading } from 'element-plus'
import axios from '@/utils/axios'
import { localRemove } from '@/utils/index'
export default {
  setup () {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const metaGroup = computed(() => route.meta.group)
    const metaTier = computed(() => route.meta.tier)
    const metaTitle = computed(() => route.meta.title)

    const goBack = () => {
      router.back()
    }
    const firstPage = ref(true)

    if (route.path == '/login') {
      firstPage.value = false
    }

    store.commit('initUserLoal')
    if (store.state.user == null || store.state.user.token_timeout * 1000 < new Date().getTime()) {
      router.replace('/login')
      return
    }
    const doExitDialog = ref(false)
    const doExit = () => {
      doExitDialog.value = false

      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios.post('/pos_cashier/logout', {
      }).then(res => {
        localRemove('token')
        window.location.href = '/'
      })
        .finally(() => {
          loading.close()
        })
    }

    return { goBack, doExit, user: store.state.user, doExitDialog, firstPage, metaGroup, metaTier, metaTitle }
  }
}
</script>
<style scoped>

.menu i{
    font-size:60pt;
}
.container_wh{

}
.left_menu{
    width: 150px;
    background-color:#101010;
}
.menu_active{
    color:#B85857;
    position: relative;
}
.menu_active::before{
    content: " ";
    position:absolute;
    left:0;
    top:10px;
    border:3px solid #B85857;
    height: 100px;
    background-color: #B85857;
}

.top_menu{
    height: 72px;
     position: relative;
}
.top_menu::after{
 content: " ";
    position:absolute;
    left:0;
    bottom:0;
     border:1px solid #f5f2f2;
     width:100%;
}
.tools,.back{
    position: relative;
    width:150px;

}
.tools::before{
    content: " ";
    position:absolute;
    left:0;
    top:2px;
    border:3px solid #B85857;
    height:25px;
    background-color: #B85857;
}
.about{
    width:220px;
}
</style>
